import BootstrapVue from 'bootstrap-vue'
import OverlayWrapper from '@/components/ui/OverlayWrapper'
import qs from 'qs'
export const getNavigatorLanguage = () => (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en-US'

const _pluginMixin = function (Vue) {
  Vue.use(BootstrapVue)
  Vue.component('overlay-wrapper', OverlayWrapper)

  Vue.config.ignoredElements = ['bicon', 'b-icon']

  // languageMixin
  Vue.mixin({
    filters: {
      translate(value, labels, key = null) {
        if (labels && labels[key] && typeof labels[key][value] === 'string') return labels[key][value]
        else if (Object.keys(labels).length > 0) return `{ ${key} | ${value} }`
        else return '~~~~~'
      },
      replace(value, keyword, replacement) {
        return value.replace(keyword, replacement)
      }
    },
    computed: {
      labels() {
        return this.$store.getters['mymachine/getConcepts']
      },
      translatedLabel() {
        return (conceptKey, conceptPath) => this.$options.filters.translate(conceptKey, this.labels, conceptPath)
      }
    },
    methods: {
      updateUrlParam(keyword, value) {
        if (window.history && history.replaceState) {
          let _newAddr = location.origin + location.pathname

          if (this && this.$route.query) {
            let items = this.$route.query
            if (value && value !== null) {
              items[keyword] = value
            } else delete items[keyword]
            if (Object.entries(items).length > 0) _newAddr += '?' + qs.stringify(items)
          } else if (value !== '') _newAddr += '?' + keyword + '=' + value
          history.replaceState('', '', _newAddr)
        }
      },
      downloadPdfFile(url) {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      }
    }
  })

  return {}
}

export default _pluginMixin
